import React from "react";
import { StaticImage } from 'gatsby-plugin-image';
import { Link } from 'gatsby';
import '../../sass/components/_components.footerPerform.scss';

const FooterPerform = () => {
    return (
        <div className="cp-footerPerform">
            <div className="cp-footerPerform__inner">
                <div className="cp-footerPerform__inner-top">
                    <Link to={`/`}>
                        <StaticImage src='../../images/planful-latest-logov3.png' alt="Planful" />
                    </Link>
                    <h3>If you're in finance or accounting, you need Planful.</h3>
                    <p>Planful is the pioneer of end-to-end financial close, consolidation, and financial planning & analysis (FP&A) cloud software. Learn how our Continuous Planning platform marries finance's need for structured planning with the business' need for dynamic planning, enabling your organization to elevate the financial conversation and make better decisions more quickly, confidently, and strategically.</p>
                </div>
                <div className="cp-footerPerform__inner-bottom l--flex">
                    <div className="l--left l--flex">
                        <span>@ {new Date().getFullYear()} Planful. All rights reserved</span>
                        <a href="https://planful.com/privacy-policy/" target="_blank" rel="noreferrer">Privacy Policy</a>
                    </div>
                    <div className="l--right">
                        <div className="cp-footer__bottom-social l--social l--flex">
                            <a className="l--genericBorderRadius l--flex" href="https://www.linkedin.com/company/planful-inc" target="_blank" rel="noreferrer" aria-label="LinkedIn, opens in a new tab">
                                <StaticImage src='../../images/linkedin-blue-v2.svg' alt="LinkedIn" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://twitter.com/Planful" target="_blank" rel="noreferrer" aria-label="Twitter, opens in a new tab">
                                <StaticImage src='../../images/twitter-blue.svg' alt="Twitter" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.instagram.com/planful_inc/" target="_blank" rel="noreferrer" aria-label="Instagram, opens in a new tab">
                                <StaticImage src='../../images/instagram-blue.svg' alt="Instagram" />
                            </a>
                            <a className="l--genericBorderRadius l--flex" href="https://www.facebook.com/PlanfulInc/" target="_blank" rel="noreferrer" aria-label="Facebook, opens in a new tab">
                                <StaticImage src='../../images/facebook-blue.svg' alt="Facebook" />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FooterPerform;